/* eslint-disable no-shadow */
import React, { Component, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import FadeIn from "react-fade-in";
import ErrorBoundary from "../shared/error/ErrorBoundary";
import ActionBar from "../shared/general/ActionBar";
import { loadEmployerPendingReviews } from "../../actions/employerPendingReviewsActions";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import Review from "./Review";
import {
  Wrapper,
  ReviewsTableWrapper,
  TableHeader,
  TableHeaderItem,
  TableBody,
  NoReviews,
} from "./styles/pending-reviews-page-styles";

export interface IPendingReviewsTableProps {
  loadEmployerPendingReviews: () => void;
  pendingReviews?: Array<PendingReviewType>;
  loading: boolean;
}

interface RecruiterType {
  name?: string;
}

interface RecruiterUserType {
  fullName?: string;
}

interface JobType {
  id?: string;
  title?: string;
}

interface PendingReviewType {
  id?: string;
  createdAt?: string;
  job?: JobType;
  recruiter?: RecruiterType;
  recruiterUser?: RecruiterUserType;
}

export class PendingReviewsTable extends Component<
  IPendingReviewsTableProps,
  unknown
> {
  static defaultProps = {
    pendingReviews: [],
  };

  static propTypes = {
    loadEmployerPendingReviews: PropTypes.func.isRequired,
    pendingReviews: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        createdAt: PropTypes.string,
        recruiter: PropTypes.shape({
          name: PropTypes.string,
        }),
        recruiterUser: PropTypes.shape({
          fullName: PropTypes.string,
        }),
        job: PropTypes.shape({
          id: PropTypes.string,
          title: PropTypes.string,
        }),
      })
    ),
  };

  componentDidMount(): void {
    const { loadEmployerPendingReviews } = this.props;
    document.body.classList.add("pending-reviews");
    loadEmployerPendingReviews();
  }

  componentWillUnmount(): void {
    document.body.classList.remove("pending-reviews");
  }

  render(): ReactNode {
    const { pendingReviews, loading } = this.props;

    return (
      <ErrorBoundary>
        <ActionBar
          capitalize
          title="Pending Reviews"
          mobileTitle="Pending Reviews"
          loading={loading}
        />
        <Wrapper>
          <ReviewsTableWrapper>
            {loading && <WidgetLoading />}
            <TableHeader>
              <TableHeaderItem flex={4}>Position</TableHeaderItem>
              <TableHeaderItem flex={3} noMobile>
                Filled By
              </TableHeaderItem>
              <TableHeaderItem flex={3} noMobile>
                Filled Date
              </TableHeaderItem>
              <TableHeaderItem flex={2} justifyContent="flex-end">
                Action
              </TableHeaderItem>
            </TableHeader>
            <TableBody>
              {pendingReviews.length < 1 ? (
                <NoReviews>
                  You have no more reviews to complete{" "}
                  <span role="img" aria-label="hands emoji">
                    🙌🏻
                  </span>
                </NoReviews>
              ) : (
                <FadeIn>
                  {pendingReviews.map((pendingReview) => (
                    <Review key={pendingReview.id} review={pendingReview} />
                  ))}
                </FadeIn>
              )}
            </TableBody>
          </ReviewsTableWrapper>
        </Wrapper>
      </ErrorBoundary>
    );
  }
}

interface IReduxState {
  employerPendingReviews: {
    pendingReviews: Array<PendingReviewType>;
    loading: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  pendingReviews: state.employerPendingReviews.pendingReviews,
  loading: state.employerPendingReviews.loading,
});

export default connect(mapStateToProps, { loadEmployerPendingReviews })(
  PendingReviewsTable
);
